import request from "../../utiles/axios";

export function customerReportPageList(data) {
  return request({
    url: "/exceptionReport/customerReportPageList",
    method: "post",
    data: data,
  });
}
/**
 * 获取租户下拉列表
 *  
 * @returns 
 */
export function getListCompanyInfo() {
  return request({
    url: "/company/listCompanyInfo",
    method: "get",
  });
}
/**
 * 完成审核
 * @param {*} data
 * @returns
 */
export function targetAudit(data) {
  return request({
    url: `/target/targetAudit`,
    method: "post",
    data,
  });
}
/**
 * 获取上报和标的详情
 * @param {string} exceptionReportId - 上报记录ID 
 * @param {string} targetId - 标的ID
 * @returns 
 */
export function getReportAndTargetDetail(exceptionReportId, targetId) {
  return request({
    url: `/exceptionReport/reportAndTargetDetail`,
    method: "get",
    params: {
      exceptionReportId,
      targetId
    }
  });
}
/**
 * 重新处理上报记录
 * @param {string} exceptionReportId - 上报记录ID
 * @returns 
 */
export function reprocessReport(exceptionReportId) {
  return request({
    url: `/exceptionReport/reprocess/${exceptionReportId}`,
    method: 'post',
    noErrorMsg: true
  });
}

/**
 * 确认处理上报
 * @param {Object} data - 请求参数
 * @param {string} data.exceptionReportId - 上报记录ID
 * @param {string} data.handleResult - 处理说明
 * @returns Promise
 */
export const confirmExceptionReport = (data) => {
  return request({
    url: '/exceptionReport/confirm',
    method: 'post',
    data,
    noErrorMsg: true
  })
}

/**
 * 重新对比标的部位
 * @param {Object} data - 请求参数
 * @param {string} data.validateTargetId - 当前标的ID
 * @param {string} data.subjectTargetId - 对比标的ID
 * @param {string} data.runType - 运行类型
 * @param {string} data.parts - 对比部位
 * @returns Promise
 */
export const rebuildPart = (data) => {
  return request({
    url: '/exceptionReport/rebuildPart',
    method: 'post',
    data
  })
}

/**
 * 保存重新对比结果
 * @param {Object} data - 请求参数
 * @param {string} data.validateTargetId - 当前标的ID
 * @param {string} data.subjectTargetId - 对比标的ID
 * @param {string} data.runType - 运行类型(固定为INSURE)
 * @param {string[]} data.parts - 对比部位
 * @param {number} data.similarity - 相似度
 * @returns Promise
 */
export const saveRebuildResult = (data) => {
  return request({
    url: '/exceptionReport/saveRebuildResult',
    method: 'post',
    data,
    noErrorMsg: true
  })
}